import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupA3 } from "../../../../../redux/app/orb3/groups/group-a";
import ORB3TableRows, { renderDataTable } from "../ORB3TableRows";

const ODS_COLUMNS = [
	{ key: "equipment", label: "Equipment" },
	{ key: "substance", label: "Discharged Substance" },
	{ key: "quantityKg", label: "Discharged Qty (Kgs)" },
];

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupA3PreviewProps = OwnProps;

function ORB3GroupA3Preview(props: ORB3GroupA3PreviewProps) {
	const record = props.orb3Record as TORB3GroupA3;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const { itemA3 } = record;

	function renderItemP1() {
		const startDTLocal = `${itemA3.startDate}T${itemA3.startTime}:00${record.timeZone}`;
		const utcStart = moment.utc(startDTLocal);
		const stopDTLocal = `${itemA3.stopDate}T${itemA3.stopTime}:00${record.timeZone}`;
		const utcStop = moment.utc(stopDTLocal);
		return (
			<>
				<h4 className="font-medium uppercase">
					Start: {utcStart.format("HH:mm")} hrs UTC on{" "}
					{utcStart.format("DD-MMM-YYYY")} ({itemA3.startTime} SMT on{" "}
					{moment(itemA3.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
				<h4 className="font-medium uppercase">
					Stop: {utcStop.format("HH:mm")} hrs UTC on{" "}
					{utcStop.format("DD-MMM-YYYY")} ({itemA3.stopTime} SMT on{" "}
					{moment(itemA3.stopDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				</h4>
			</>
		);
	}

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[
					[
						operationDate,
						"3-A",
						itemA3.dischargeType === "Deliberate" ? "1.3.1" : "1.3.2",
						`Discharge Type: ${itemA3.dischargeType}`,
					],
					[null, null, "-", renderItemP1()],
					[
						null,
						null,
						"-",
						`Position: ${itemA3.vesselPosition.latitude} / ${itemA3.vesselPosition.longitude}`,
					],
					[null, null, "-", renderDataTable(itemA3.items, ODS_COLUMNS)],
					[null, null, "NOTE", record.remarks],
				]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupA3Preview;
